// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"photo_wrapper__2236u","meta":"photo_meta__2m0X9","shadow":"photo_shadow__1LDgu","background":"photo_background__OUEhD","copy":"photo_copy__vc4vf"};